<template>
  <Modal
    ref="modal"
    title="New Email Template"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="createEmailTemplate"
  >
    <TextInput
      label="Template Name"
      placeholder="Enter a name for this Email template"
      :model-value="email.templateName"
      @update:model-value="value => (email.templateName = value)"
    />
    <TextInput
      ref="subjectInput"
      class="mt-4"
      label="Email Subject"
      placeholder="Greetings from earth!"
      :model-value="email.subject"
      @update:model-value="value => (email.subject = value)"
    />
    <div class="mt-8 flex space-x-3">
      <div class="min-w-0 flex-1">
        <QuillInput
          ref="quillInput"
          v-model="email.body"
          name="new-email"
          label="New Email"
          :label-sr-only="true"
          size="large"
        />
      </div>
    </div>
    <MergeTagSelect class="mt-4" @selected-tag="tag => $refs.quillInput.insertMergeTagAtCursor(tag)" />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { sanitizeRichText } from '../../../utilities/sanitization.ts';
import QuillInput from '../../shared/QuillInput.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import MergeTagSelect from '@/components/shared/merge_tag/MergeTagSelect/index.vue';
import { hFetch } from '@/api/hFetch';
import { mergeTagQuillParser } from '@/components/shared/merge_tag/quill_input/mergeTagQuillParser.ts';

export default {
  components: {
    Modal,
    QuillInput,
    MergeTagSelect,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      email: {
        templateName: '',
        subject: '',
        body: '',
      },
    };
  },
  methods: {
    sanitize(html) {
      return sanitizeRichText(html);
    },
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    async createEmailTemplate() {
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      const response = await hFetch({
        url: '/api/email_templates',
        method: 'POST',
        payload: {
          name: this.email.templateName,
          subject: this.email.subject,
          body: mergeTagQuillParser().serialize(this.email.body),
        },
      });

      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      if (response.status != 'error') {
        toast.success('Email template saved', {
          action: { label: 'Dismiss' },
          description: 'Your Email Template email was successfully saved.  Use the button below to dismiss this alert.',
        });
        this.$emit('handleSaveSettings');
      } else {
        toast.error('Email template save error', {
          action: { label: 'Dismiss' },
          description: response.message,
        });
      }
    },
  },
};
</script>
